import React from 'react'

export default function FaceFeature({ scaleX, fill }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path d="M68.78 0L66.71 6.5L68.78 9.88L70.92 6.5L68.78 0Z" fill={fill} /* "white" */ />
      <path d="M2.06 0L0 6.5L2.06 9.88L4.20996 6.5L2.06 0Z" fill={fill} /* "white" */ />
    </g>
  )
}
